/**
 *   Generated file. Do not edit
 */

import { ModbusVariableAddress } from './models';
import { VariableType } from './models';
import { VariableMeta } from './models';
import { ReadWriteRights } from '@iotize/tap/service/impl/bundle';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readModbusVariableAddress(): ModbusVariableAddress;

    readVariableType(): VariableType;

    readVariableMeta(): VariableMeta;
  }
  export interface TapStreamWriter {
    writeModbusVariableAddress(model: ModbusVariableAddress): TapStreamWriter;

    writeVariableType(model: VariableType): TapStreamWriter;

    writeVariableMeta(model: VariableMeta): TapStreamWriter;
  }
}

TapStreamReader.prototype.readModbusVariableAddress =
  function (): ModbusVariableAddress {
    const model: Partial<ModbusVariableAddress> = {};

    model.functionCode = this.readUnsigned(1);

    model.slave = this.readUnsigned(1);

    model.address = this.readUnsigned(2);

    return model as ModbusVariableAddress;
  };

TapStreamReader.prototype.readVariableType = function (): VariableType {
  const model: Partial<VariableType> = {};

  model.domain = this.readBits(2);

  model.data = this.readBits(6);

  return model as VariableType;
};

TapStreamReader.prototype.readVariableMeta = function (): VariableMeta {
  const model: Partial<VariableMeta> = {};

  model.name = this.readStringTerminator(':');

  model.unit = this.readString();

  return model as VariableMeta;
};

// TapStreamWriter.prototype.write(model: ModbusVariableAddress) : TapStreamWriter{
//     return this.writeModbusVariableAddress(model)
// }

TapStreamWriter.prototype.writeModbusVariableAddress = function (
  model: ModbusVariableAddress,
): TapStreamWriter {
  this.writeUnsigned(model.functionCode, 1);

  this.writeUnsigned(model.slave, 1);

  this.writeUnsigned(model.address, 2);

  return this;
};

// TapStreamWriter.prototype.write(model: VariableType) : TapStreamWriter{
//     return this.writeVariableType(model)
// }

TapStreamWriter.prototype.writeVariableType = function (
  model: VariableType,
): TapStreamWriter {
  this.writeBitsInt(
    enumKeyOrValueToNumber<VariableType.Domain>(
      model.domain,
      VariableType.Domain,
    ),
    2,
  );

  this.writeBitsInt(
    enumKeyOrValueToNumber<VariableType.Data>(model.data, VariableType.Data),
    6,
  );

  return this;
};

// TapStreamWriter.prototype.write(model: VariableMeta) : TapStreamWriter{
//     return this.writeVariableMeta(model)
// }

TapStreamWriter.prototype.writeVariableMeta = function (
  model: VariableMeta,
): TapStreamWriter {
  this.writeString(model.name + ':');

  this.writeString(model.unit);

  return this;
};
